import { apiJson } from '@/api/client'
import type {
  Transaction,
  TransactionsListFilters,
  TransactionsSummaryListResponse,
} from './types'

export function getTransaction(id: string): Promise<Transaction> {
  return apiJson<Transaction>(`/transactions/${id}`)
}

function paramsFor(f: TransactionsListFilters = {}): string {
  const sp = new URLSearchParams()
  if (f.q) sp.set('q', f.q)
  for (const c of f.channel ?? []) sp.append('channel', c)
  for (const s of f.status ?? []) sp.append('status', s)
  if (f.date_from) sp.set('date_from', f.date_from)
  if (f.date_to) sp.set('date_to', f.date_to)
  if (f.amount_min_minor !== undefined)
    sp.set('amount_min_minor', String(f.amount_min_minor))
  if (f.amount_max_minor !== undefined)
    sp.set('amount_max_minor', String(f.amount_max_minor))
  if (f.customer_id) sp.set('customer_id', f.customer_id)
  if (f.nuban) sp.set('nuban', f.nuban)
  if (f.branch) sp.set('branch', f.branch)
  const s = sp.toString()
  return s ? `?${s}` : ''
}

export function listTransactions(
  filters: TransactionsListFilters = {},
): Promise<TransactionsSummaryListResponse> {
  return apiJson<TransactionsSummaryListResponse>(
    `/transactions${paramsFor(filters)}`,
  )
}
